import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Divider } from 'antd';
import moment from "moment";
import { FORMAT_NUMBER, FORMAT_3DECIMALS, } from "../../../../common/types/regularExpresionType";
import Resumen from './Resumen';
import CierreSoles from './CierreSoles';
import CierreDolares from './CierreDolares';
import ResumenDolares from './ResumenDolares';

import AjusteCaja from './AjusteCaja';

const { Option } = Select;
const InputGroup = Input.Group;
const { Search } = Input;
const { TabPane } = Tabs;

class CierreModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCompleteDecimals = (property, value) => {
        if (value === "" || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: "0.000" });
        else
            this.props.form.setFieldsValue({
                [property]: parseFloat(value).toFixed(3),
            });
    };

    handleCalculateDetail = (row, property, value, numberDecimals) => {

        /*********** Actualizar Detalle de Productos ********/
        var detalleProductos = this.props.form.getFieldValue("detalleSoles");
        var detalleAjuste = this.props.form.getFieldValue("detalleAjuste");
        var detalleAjusteFilter = [];

        var detalleProductosFilter = [];

        detalleProductos.forEach(element => {

            if (element.id === row.id) {
                detalleProductosFilter.push({
                    id_CajaApertura: this.props.formValues.id,
                    abreviatura: element.abreviatura,
                    cantidad: parseInt(value),
                    formato: element.formato,
                    id: element.id,
                    id_Moneda: element.id_Moneda,
                    monto: element.monto,
                    total: element.monto * value
                });

            } else {

                detalleProductosFilter.push({
                    id_CajaApertura: this.props.formValues.id,
                    abreviatura: element.abreviatura,
                    cantidad: parseInt(element.cantidad),
                    formato: element.formato,
                    id: element.id,
                    id_Moneda: element.id_Moneda,
                    monto: element.monto,
                    total: element.total
                });
            }


        });

        debugger
        var totalSoles = detalleProductosFilter.filter(value => value.id_Moneda == 1).reduce((a, b) => a + (b["total"] || 0), 0)

        detalleAjuste.forEach(element => {
            if (element.moneda == "SOLES") {
                detalleAjusteFilter.push({
                    id: element.id,
                    idAperturaCaja: element.idAperturaCaja,
                    idMoneda: element.idMoneda,
                    moneda: element.moneda,
                    opcion: element.opcion,
                    totalCaja: totalSoles,
                    totalEfectivo: element.totalEfectivo,
                    totalfaltante: (totalSoles - element.totalEfectivo),
                    idResposanbleArqueo: element.idResposanbleArqueo == undefined ? 0 : element.idResposanbleArqueo

                });
            } else {

                detalleAjusteFilter.push({
                    id: element.id,
                    idAperturaCaja: element.idAperturaCaja,
                    idMoneda: element.idMoneda,
                    moneda: element.moneda,
                    opcion: element.opcion,
                    totalCaja: element.totalCaja,
                    totalEfectivo: element.totalEfectivo,
                    totalfaltante: element.totalfaltante,
                    idResposanbleArqueo: element.idResposanbleArqueo == undefined ? 0 : element.idResposanbleArqueo

                });
            }
        });


        this.props.form.setFieldsValue({
            detalleSoles: detalleProductosFilter

        });
        this.props.form.setFieldsValue({
            detalleAjuste: detalleAjusteFilter

        });


        this.props.formValues.listaEfectivoSoles = detalleProductosFilter;
        this.props.formValues.listaAjuste = detalleAjusteFilter;


    };

    handleCalculateDolar = (row, property, value, numberDecimals) => {

        /*********** Actualizar Detalle de Productos ********/
        var detalleProductos = this.props.form.getFieldValue("detalleDolares");

        var detalleProductosFilter = [];

        detalleProductos.forEach(element => {

            if (element.id === row.id) {
                detalleProductosFilter.push({
                    id_CajaApertura: this.props.formValues.id,
                    abreviatura: element.abreviatura,
                    cantidad: parseInt(value),
                    formato: element.formato,
                    id: element.id,
                    id_Moneda: element.id_Moneda,
                    monto: element.monto,
                    total: element.monto * value
                });

            } else {

                detalleProductosFilter.push({
                    id_CajaApertura: this.props.formValues.id,
                    abreviatura: element.abreviatura,
                    cantidad: parseInt(element.cantidad),
                    formato: element.formato,
                    id: element.id,
                    id_Moneda: element.id_Moneda,
                    monto: element.monto,
                    total: element.total
                });
            }


        });

        var detalleAjuste = this.props.form.getFieldValue("detalleAjuste");
        var detalleAjusteFilter = [];

        debugger
        var totalDolares = detalleProductosFilter.filter(value => value.id_Moneda == 2).reduce((a, b) => a + (b["total"] || 0), 0)

        detalleAjuste.forEach(element => {
            if (element.moneda != "SOLES") {
                detalleAjusteFilter.push({
                    id: element.id,
                    idAperturaCaja: element.idAperturaCaja,
                    moneda: element.moneda,
                    idMoneda: element.idMoneda,
                    opcion: element.opcion,
                    totalCaja: totalDolares,
                    totalEfectivo: element.totalEfectivo,
                    totalfaltante: (totalDolares - element.totalEfectivo),
                    idResposanbleArqueo: element.idResposanbleArqueo == undefined ? 0 : element.idResposanbleArqueo

                });
            } else {

                detalleAjusteFilter.push({
                    id: element.id,
                    idAperturaCaja: element.idAperturaCaja,
                    moneda: element.moneda,
                    idMoneda: element.idMoneda,
                    opcion: element.opcion,
                    totalCaja: element.totalCaja,
                    totalEfectivo: element.totalEfectivo,
                    totalfaltante: element.totalfaltante,
                    idResposanbleArqueo: element.idResposanbleArqueo == undefined ? 0 : element.idResposanbleArqueo

                });
            }
        });



        this.props.form.setFieldsValue({
            detalleDolares: detalleProductosFilter

        });

        this.props.form.setFieldsValue({
            detalleAjuste: detalleAjusteFilter

        });



        this.props.formValues.listaEfectivoDolares = detalleProductosFilter;
        this.props.formValues.listaAjuste = detalleAjusteFilter;


    };


    onCalculateDetailAjuste = (row, property, value, numberDecimals, index) => {
        var detalleAjuste = this.props.form.getFieldValue("detalleAjuste");
        var detalleAjusteFilter = [];

        detalleAjuste.forEach(element => {
            if (element.id == row.id) {
                detalleAjusteFilter.push({
                    id: element.id,
                    idAperturaCaja: element.idAperturaCaja,
                    moneda: element.moneda,
                    idMoneda: element.idMoneda,
                    opcion: element.opcion,
                    totalCaja: element.totalCaja,
                    totalEfectivo: element.totalEfectivo,
                    totalfaltante: parseFloat(value),
                    opcion: element.opcion,
                    idResposanbleArqueo: element.idResposanbleArqueo == undefined ? 0 : element.idResposanbleArqueo

                });
            } else {

                detalleAjusteFilter.push({
                    id: element.id,
                    idAperturaCaja: element.idAperturaCaja,
                    moneda: element.moneda,
                    idMoneda: element.idMoneda,
                    opcion: element.opcion,
                    totalCaja: element.totalCaja,
                    totalEfectivo: element.totalEfectivo,
                    totalfaltante: element.totalfaltante,
                    opcion: element.opcion,
                    idResposanbleArqueo: element.idResposanbleArqueo == undefined ? 0 : element.idResposanbleArqueo

                });
            }

        });


        this.props.form.setFieldsValue({
            detalleAjuste: detalleAjusteFilter
        });


        this.props.formValues.listaAjuste = detalleAjusteFilter;


    }

    handleCancel = () => {
        this.props.onClose();
        //this.props.form.resetFields();
    }

    handleEfectivos = () => {

        var detalleSoles = this.props.form.getFieldValue("detalleSoles");
        var detalleDolares = this.props.form.getFieldValue("detalleDolares");

        var detalleAjuste = this.props.form.getFieldValue("detalleAjuste");

        var result = detalleSoles.concat(detalleDolares);

        const validFormLogic = this.validateFormLogic(detalleSoles, detalleDolares, result);
        if (!validFormLogic) {
            return;
        }

        this.props.onSave(result, detalleAjuste, this.props.form);
    }

    handleCombo = (data, value) => {

        var detalleAjuste = this.props.form.getFieldValue("detalleAjuste");
        var detalleAjusteFilter = [];

        detalleAjuste.forEach(element => {

            detalleAjusteFilter.push({
                id: element.id,
                idAperturaCaja: element.idAperturaCaja,
                moneda: element.moneda,
                idMoneda: element.idMoneda,
                opcion: element.opcion,
                totalCaja: element.totalCaja,
                totalEfectivo: element.totalEfectivo,
                totalfaltante: element.totalfaltante,
                opcion: element.opcion,
                idResposanbleArqueo: data.key == undefined ? 0 : data.key
            });

        });


        this.props.form.setFieldsValue({
            detalleAjuste: detalleAjusteFilter
        });


        this.props.formValues.listaAjuste = detalleAjusteFilter;





    }

    validateFormLogic = (detalleSoles, detalleDolares) => {

        var result = this.props.formValues.listaResumen;
        /*   if (result.length == 0) {
   
             dialog.error('No se puede cerrar la caja por que no realizo ninguna venta');
   
             return false;
         }
   
        var totalDolares =props.formValues.listaEfectivoDolares.reduce((a, b) => a + (b["total"] || 0), 0)
         var totalSoles =props.formValues.listaEfectivoSoles.reduce((a, b) => a + (b["total"] || 0), 0)
   this.props.formValues.id,
      */
        /*   
              var totalDolares =this.props.formValues.listaEfectivoDolares.reduce((a, b) => a + (b["total"] || 0), 0)
              var totalSoles =this.props.formValues.listaEfectivoSoles.reduce((a, b) => a + (b["total"] || 0), 0)
            
              console.log(totalDolares);
              console.log(totalSoles); */


        return true;
    };


    handleAjuste = (row, value) => {

        /*********** Actualizar Detalle de Productos ********/

        var detalleAjuste = this.props.form.getFieldValue("detalleAjuste");
        var detalleAjusteFilter = [];



        detalleAjuste.forEach(element => {
            if (element.id == row.id) {
                detalleAjusteFilter.push({
                    id: element.id,
                    idAperturaCaja: element.idAperturaCaja,
                    moneda: element.moneda,
                    idMoneda: element.idMoneda,
                    totalCaja: element.totalCaja,
                    totalEfectivo: element.totalEfectivo,
                    totalfaltante: element.totalfaltante,
                    opcion: value,
                    idResposanbleArqueo: element.idResposanbleArqueo == undefined ? 0 : element.idResposanbleArqueo

                });
            } else {

                detalleAjusteFilter.push({
                    id: element.id,
                    idAperturaCaja: element.idAperturaCaja,
                    moneda: element.moneda,
                    idMoneda: element.idMoneda,
                    totalCaja: element.totalCaja,
                    totalEfectivo: element.totalEfectivo,
                    totalfaltante: element.totalfaltante,
                    opcion: element.opcion,
                    idResposanbleArqueo: element.idResposanbleArqueo == undefined ? 0 : element.idResposanbleArqueo

                });
            }

        });

        this.props.form.setFieldsValue({
            detalleAjuste: detalleAjusteFilter
        });


        this.props.formValues.listaAjuste = detalleAjusteFilter;


    };


    render() {

        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        getFieldDecorator("detalleSoles", {
            initialValue: this.props.formValues.listaEfectivoSoles,
        });


        getFieldDecorator("detalleDolares", {
            initialValue: this.props.formValues.listaEfectivoDolares,
        });


        getFieldDecorator("detalleAjuste", {
            initialValue: this.props.formValues.listaAjuste,
        });



        return (
            <Modal
                title={"Arqueo de Caja"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleEfectivos}
                style={{ top: 30 }}
                width="1000px"
            >
                <Form>


                    <div className="row">

                        <div className="col-md-3">
                            <Form.Item label="Nro  Planilla">


                                <InputGroup compact>
                                    <Form.Item style={{ width: "40%" }}>
                                        {getFieldDecorator("serie", {
                                            initialValue: this.props.formValues.serie,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Serie"
                                                autoComplete="off"

                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "60%" }}>
                                        {getFieldDecorator("correlativo", {
                                            initialValue: this.props.formValues.correlativo,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Correlativo",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"

                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>


                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Fecha Apertura/ Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "65%" }}>
                                        {getFieldDecorator("FechaTipoCambio", {
                                            initialValue: moment(
                                                this.props.formValues.FechaTipoCambio,
                                                "DD/MM/YYYY"
                                            ),
                                            rules: [
                                                {
                                                    type: "object",
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={
                                                    <Icon
                                                        type="filter"
                                                        style={{ color: "rgba(0,0,0,.25)" }}
                                                    />
                                                }
                                                disabled={true}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) =>
                                                    this.props.onChange(
                                                        "fechaStr",
                                                        value,
                                                        this.props.form
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "35%" }}>
                                        {getFieldDecorator("TipoCambio", {
                                            initialValue: parseFloat(
                                                this.props.formValues.TipoCambio
                                            ).toFixed(3),
                                            rules: [
                                                {
                                                    required: true,
                                                    pattern: new RegExp(FORMAT_3DECIMALS),
                                                    message: "Formato decimal incorrecto (0.000)",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) =>
                                                    this.handleCompleteDecimals(
                                                        "TipoCambio",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>

                        <div className="col-md-3">
                            <Form.Item label="Fecha Cierre">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "100%" }}>
                                        {getFieldDecorator("FechaTipoCambio", {
                                            initialValue: moment(
                                                this.props.formValues.FechaTipoCambio,
                                                "DD/MM/YYYY"
                                            ),
                                            rules: [
                                                {
                                                    type: "object",
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={
                                                    <Icon
                                                        type="filter"
                                                        style={{ color: "rgba(0,0,0,.25)" }}
                                                    />
                                                }
                                                disabled={true}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) =>
                                                    this.props.onChange(
                                                        "fechaStr",
                                                        value,
                                                        this.props.form
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Responsable de arqueo">
                                {getFieldDecorator("idResposanbleArqueo", {
                                    initialValue: this.props.formValues.idResposanbleArqueo
                                        ? { key: this.props.formValues.idResposanbleArqueo }
                                        : undefined,
                                    rules: [
                                        {
                                            required: false,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select

                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Responsable"}
                                        optionFilterProp="children"
                                        onChange={(moment, value) => this.handleCombo(moment, value)
                                        }
                                    >
                                        <Option key={0}  >
                                            Ninguno
                                        </Option>

                                        {this.props.formValues.listaEmpleado.map((item) => (
                                            <Option key={item.id} value={item.id} >
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>



                    <div className="row">
                        <div className="col-md-4">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator("idEstablecimiento", {
                                    initialValue: this.props.formValues.idEstablecimiento
                                        ? { key: this.props.formValues.idEstablecimiento }
                                        : undefined,
                                    rules: [
                                        {
                                            required: false,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.listaEstablecimiento.map((item) => (
                                            <Option key={item.id} value={item.id} disabled>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Caja">
                                {getFieldDecorator("idCaja", {
                                    initialValue: this.props.formValues.idCaja
                                        ? { key: this.props.formValues.idCaja }
                                        : undefined,
                                    rules: [
                                        {
                                            required: false,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select

                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Caja"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.listaCaja.map((item) => (
                                            <Option key={item.id} value={item.id} disabled>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-4">
                            <Form.Item label="Responsable de Caja">
                                {getFieldDecorator('responsable', {
                                    initialValue: this.props.formValues.responsable,
                                    rules: [{
                                        required: false,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Search
                                        readOnly
                                        placeholder="Búsqueda por Documento"
                                        autoComplete="off"
                                        maxLength={20}
                                    //loading={this.props.formValues.searchLoading}
                                    //onSearch={this.handleFilter}
                                    />
                                )}
                            </Form.Item>
                        </div>


                    </div>



                    <div className="row">

                        <div className="col-md-6">
                            <Divider orientation="left" dashed>Saldo Inicial Soles: <span>{this.props.formValues.saldoSoles.toFixed(2)}</span> </Divider>

                        </div>
                        <div className="col-md-6">
                            <Divider orientation="left">Saldo Inicial Dolares: <span>{this.props.formValues.saldoDolares.toFixed(2)}</span> </Divider>

                        </div>

                        <div className="col-md-12">
                            <Divider style={{ fontWeight: 'bold' }} orientation="left"></Divider>

                        </div>
                    </div>


                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Tabs>
                                <TabPane tab="Resumen Soles" key="1">
                                    <Resumen
                                        dataSource={this.props.formValues.listaResumen.filter(value => value.moneda == "SOLES")}
                                    />
                                </TabPane>

                            </Tabs>
                        </div>

                        <div className="col-md-6 form-group">
                            <Tabs>
                                <TabPane tab="Resumen Dólares" key="2">
                                    <ResumenDolares
                                        dataSource={this.props.formValues.listaResumen.filter(value => value.moneda != "SOLES")}
                                    />
                                </TabPane>

                            </Tabs>
                        </div>

                    </div>




                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs>
                                <TabPane tab="Resumen Efectivo Caja" key="1">
                                    <div className="row">
                                        <div className="col-md-6 form-group">
                                            <CierreSoles
                                                dataSource={this.props.formValues.listaEfectivoSoles}
                                                onGetFieldDecorator={getFieldDecorator}
                                                onCalculateDetail={this.handleCalculateDetail}

                                            />
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <CierreDolares
                                                dataSource={this.props.formValues.listaEfectivoDolares}
                                                onGetFieldDecorator={getFieldDecorator}
                                                handleCalculateDolar={this.handleCalculateDolar}

                                            />
                                        </div>
                                    </div>


                                </TabPane>

                            </Tabs>
                        </div>

                    </div>



                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs>
                                <TabPane tab="Ajuste Caja" key="1">
                                    <div className="row">
                                        <div className="col-md-12 form-group">
                                            <AjusteCaja
                                                dataSource={this.props.formValues.listaAjuste}
                                                updateShow={this.handleAjuste}
                                                onGetFieldDecorator={getFieldDecorator}
                                                onSetFieldsValue={setFieldsValue}
                                                onGetFieldValue={getFieldValue}
                                                onCalculateDetail={this.onCalculateDetailAjuste}
                                            />
                                        </div>

                                    </div>


                                </TabPane>

                            </Tabs>
                        </div>

                    </div>


                </Form>
            </Modal>
        );
    }
}
export default Form.create()(CierreModal)